/** Filtro compacto de cliente p/ toolbars (Popover sobre o ClientPicker). */
import { useState } from 'react';
import { ChevronDown, X } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { ClientPicker, type ClientRef } from '@/features/tickets/ClientPicker';
import { cn } from '@/lib/utils';

export function ClientFilter({
  selected,
  onSelect,
}: {
  selected: ClientRef | null;
  onSelect: (client: ClientRef | null) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className={cn(
              'flex h-8 w-56 items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 text-sm shadow-xs outline-none transition-[color,box-shadow]',
              'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50'
            )}
          >
            <span className={cn('truncate', !selected && 'text-muted-foreground')}>
              {selected ? selected.name : 'Todos os clientes'}
            </span>
            <ChevronDown className="size-4 shrink-0 text-muted-foreground" aria-hidden />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-80 p-3">
          <ClientPicker
            selected={null}
            onSelect={(client) => {
              onSelect(client);
              setOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
      {selected ? (
        <button
          type="button"
          onClick={() => onSelect(null)}
          aria-label="Limpar filtro de cliente"
          className="flex size-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
